import type { Station } from "../domain/model.ts";

/** A facility can remain a depot in the route model while using reserved styling on the map. */
export function isReservedDisplayStation(station: Pick<Station, "id" | "lineId" | "stationType">): boolean {
  return station.stationType === "reserved"
    || (station.lineId === "AMTR-L4" && station.id === "caicuo-depot");
}

/** A facility can remain a depot in the route model while using non-operating styling on the map. */
export function isNonOperatingDisplayStation(station: Pick<Station, "id" | "lineId">): boolean {
  return station.lineId === "AMTR-L6" && station.id === "binhai-depot";
}
